import { useQueryClient } from '@tanstack/react-query';
import { useMemo } from 'react';
import { PlanningsDeliveriesCache } from 'src/utils/cache/PlanningsDeliveriesCache';
import { PlanningsDeliveriesWithLegRunsCache } from 'src/utils/cache/PlanningsDeliveriesWithLegRunsCache';
import { PlanningsDriversCache } from 'src/utils/cache/PlanningsDriversCache';
import { PlanningsOrdersCache } from 'src/utils/cache/PlanningsOrdersCache';
import { PlanningsTrucksCache } from 'src/utils/cache/PlanningsTrucksCache';
import { ProjectCache } from 'src/utils/cache/ProjectCache';

/**
 * PlanningsTrucksのキャッシュ操作を提供するカスタムフック
 */
export const usePlanningsTrucksCache = () => {
  const queryClient = useQueryClient();

  return useMemo(() => new PlanningsTrucksCache(queryClient), [queryClient]);
};

export const usePlanningsDriversCache = () => {
  const queryClient = useQueryClient();

  return useMemo(() => new PlanningsDriversCache(queryClient), [queryClient]);
};

export const usePlanningsDeliveriesCache = () => {
  const queryClient = useQueryClient();

  return useMemo(() => new PlanningsDeliveriesCache(queryClient), [queryClient]);
};

export const usePlanningsOrdersCache = () => {
  const queryClient = useQueryClient();

  return useMemo(() => new PlanningsOrdersCache(queryClient), [queryClient]);
};

export const useProjectCache = () => {
  const queryClient = useQueryClient();

  return useMemo(() => new ProjectCache(queryClient), [queryClient]);
};

export const usePlanningsDeliveriesWithLegRunsCache = () => {
  const queryClient = useQueryClient();

  return useMemo(() => new PlanningsDeliveriesWithLegRunsCache(queryClient), [queryClient]);
}
